export const WATERMARK_WARNING_TEXT =
  '*EDC squared watermark is for preview reasons only and will be removed before go live. ';

export const SUCCESS_MESSAGES = {
  Rejected: 'Rejected Successfully',
  Approved: 'Approved Successfully',
};
